/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 * 
 */
require('./bootstrap');
import Vue from 'vue';

import Vuelidate from 'vuelidate';
Vue.use(Vuelidate)

Vue.component('konfigurator', require('./components/Konfigurator/Main.vue').default);
Vue.component('whitepaper-form', require('./components/WhitepaperForm.vue').default);
Vue.component('appointment', require('./pages/Appointment.vue').default);

const app = new Vue({}).$mount('#app');